import React, { useState } from 'react';

const SwitchComponent = ({ isMonthly, handleIsMonthly }) => {
    return (
        <div className="flex items-center justify-center mt-5">
            <div className="flex items-center bg-gray-800 rounded-full">
                <button
                    className={`px-4 py-2 rounded-full transition-all text-white uppercase font-medium ${isMonthly ? 'bg-lt-blue' : 'bg-lt-dark-blue'}`}
                    onClick={handleIsMonthly}
                >
                    Monthly
                </button>
                <button
                    className={`px-4 py-2 rounded-full transition-all text-white uppercase font-medium ${!isMonthly ? 'bg-lt-blue' : 'bg-lt-dark-blue'}`}
                    onClick={handleIsMonthly}
                >
                    Yearly
                </button>
            </div>
        </div>
    );
};

export default SwitchComponent;